import {
  LIST_SUPPLIERS,
  CREATE_SUPPLIER,
  UPDATE_SUPPLIER,
} from '@/data/actions/modules/general';

export default [
  {
    path: '/providers',
    component: () => import(/* webpackChunkName: "providers" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: LIST_SUPPLIERS,
    },
  },
  {
    path: '/providers/create',
    component: () => import(/* webpackChunkName: "providers" */ './components/Form.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: CREATE_SUPPLIER,
    },
  },
  {
    path: '/providers/:id/edit',
    component: () => import(/* webpackChunkName: "providers" */ './components/Form.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: UPDATE_SUPPLIER,
    },
  },
];
